import React from "react";

export default function Module_1() {
    return (
        <>
            <h2 className="py-3">
                We offer a customer experience unlike any other in the industry
            </h2>
            <p>
                Is it because we’re responsive and good at solving problems? Is
                it our eagerness to exceed expectations? Or is it simply our
                no-nonsense approach to business?
            </p>
            <p>
                We’re not entirely sure. But we do make a point of being easy to
                work with. It’s the best way we’ve found to drive customer
                satisfaction and ensure the success of lighting projects.
            </p>
        </>
    );
}
